module.exports = __webpack_public_path__ + "public/img/long.9009d1f4.jpg";